<template>
  <footer class="pa-index-footer">
    <hr class="footer-separator" />

    <section class="pa-footer-links">
      <router-link to="/terms">利用規約</router-link>
      &nbsp;/&nbsp;
      <router-link to="/privacy">プライバシーポリシー</router-link>
    </section>

    <section class="pa-office-logo">
      <OfficeLogo />
    </section>

    <section class="pa-copyright">
      <CopyLogo />
    </section>
  </footer>
</template>

<script>
import OfficeLogo from '@/components/FrontParts/PaIndexFooter/Images/24th.svg?inlineN'
import CopyLogo   from '@/components/FrontParts/PaIndexFooter/Images/copyright.svg?inlineN'

export default {
  components : {
    OfficeLogo,
    CopyLogo
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";
@import "~bulma/sass/utilities/_all";

.pa-index-footer{
  hr.footer-separator{
    background-color: inherit;
    margin:1.4rem 0;
    background-color: $footer-separator-background;
    background-image: url('./Images/footer_separator.svg');
    height:2rem;

    border-top:6px solid $footer-separator-border;
    border-bottom:6px solid $footer-separator-border;

    @include from($tablet) {
      height:30px;
    }
  }

  section.pa-footer-links{
    margin:1rem 0;
    text-align: center;

    @include from($tablet) {
      margin:1rem 0;
    }

    a{
      color:$footer-link-anchor;
      font-weight: bold;
      font-size:1.1rem;

      @include from($tablet) {
        font-size:1rem;
      }
    }
  }

  section.pa-office-logo{
    margin:4px auto 0;
    width:14rem;

    @include from($tablet) {
      width:14rem;
    }

    svg{
      .cls-1{
        fill: #531223;
      }
    }
  }

  section.pa-copyright{
    margin:0 auto 0;
    padding:0;
    text-align: center;
    width:20rem;

    @include from($tablet) {
      width:30rem;
    }
  }
}
</style>